import React from 'react';
import styled from 'styled-components';

import { palette } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import { BaseConfetti } from 'src/elements/confetti/confetti.styles';
import Image from 'src/elements/image/image';

export const ModalBackdrop = styled.div`
  background: rgba(77, 84, 97, 0.7);
  width: 100%;
  max-width: none!important; //!important needed to override default layout max-width
  height: 100%;
  position: fixed;
  top: 0;
  z-index: 100;
  animation: fadeIn .2s;
  padding: 0 30px;
  box-sizing: border-box;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const Modal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  max-width: 750px;
  padding-top: 100px;
  margin: 0 auto;
  margin-top: 8%;
  background-color: ${palette.white};
  background-repeat: no-repeat;
  background-position: left -42px bottom -1px, top 41px right 170px, bottom 150px right 90px, top 113px left 45px;
  background-size: 176px, auto, auto, auto;
  border-radius: 5px;
  overflow: hidden;

  @media only screen and (min-width: ${layout.sm}) {
    background-position: left bottom, top 41px right 170px, bottom 150px right 90px, top 113px left 45px;
    background-size: auto;
  }
`;

export const ModalTitleWrapper = styled.div`
  margin-bottom: 35px;
  font-feature-settings: 'ordn' on;
  max-width: 200px;

  @media only screen and (min-width: ${layout.sm}) {
    max-width: none;
  }
`;

export const DescriptionTextWrapper = styled.div`
  max-width: 245px;
  line-height: 28px;
  margin-bottom: 45px;
  font-weight: 300;
  font-size: 16px;
  text-align: center;

  @media only screen and (min-width: ${layout.sm}) {
    max-width: 390px;
    line-height: 28px;
    font-size: 22px;
  }
`;

export const CloseButton = styled.div`
  /* Modal as it's parent/position: relative */
  position: absolute;
  top: 20px;
  right: 20px;
  color: ${palette.steelTeal};
  font-size: 22px;
  padding: 0;
  cursor: pointer;
`;

export const NoThanksButtonWrapper = styled.div`
  margin-top: 10px;
`;

export const TermsAndConditionsLabel = styled.p`
  display: block;
  font-weight: 700;
  font-size: 9px;
  line-height: 11px;
  margin-top: 45px;
  margin-bottom: 20px;

  @media only screen and (min-width: ${layout.sm}) {
    font-weight: 400;
  }
`;

// Confetti

export const Confetti1 = styled(BaseConfetti).attrs({
  width: 22,
  height: 23,
  viewBox: '0 0 22 23',
  children: <path d="M12.6777 35.3549L25.1831 22.7363L25.1831 12.505L12.6777 5.34058e-05L0.17244 12.505L0.172419 22.7362L12.6777 35.3549Z" fill="#80D1CD"/>
})`
  top: 19%;
  left: 5%;
  transform: rotate(-37deg) scale(.81);
`;

export const Confetti2 = styled(BaseConfetti).attrs({
  width: 22,
  height: 23,
  viewBox: '0 0 22 23',
  children: <path d="M16.6451 22.6177L2.19935 2.00396L19.6917 5.03461L16.6451 22.6177Z" fill="#7A0090" />
})`
  top: 8%;
  right: 44%;
  transform: rotate(-90deg);

  @media only screen and (min-width: ${layout.sm}) {
    right: 22%;
  }
`;

export const Confetti3 = styled(BaseConfetti).attrs({
  width: 22,
  height: 23,
  viewBox: '0 0 22 23',
  children: <path d="M19.3713 37.4744L23.7889 2.56197L9.82397 0.794923L0.569806 7.97017L19.3713 37.4744Z" fill="#ff7062" />
})`
  bottom: 34%;
  right: 11%;
  transform: rotate(30deg) scale(.8);

  @media only screen and (min-width: ${layout.sm}) {
    bottom: 29%;
  }
`;

export const BackgroundHexagon = styled(Image)`
  position: absolute!important; //!important needed to override inline position
  left: -39px;
  bottom: 0;
  width: 172px;
  pointer-events: none;

  @media only screen and (min-width: ${layout.sm}) {
    left: 0;
    width: 216px;
  }
`;
